import React, { useEffect, useState,useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { envAwarePost } from "../../util/util";
import classicImg from "../../assets/img/trainerPage/classic.png";
import modernImg from "../../assets/img/trainerPage/modern.png";
import modernV2Img from "../../assets/img/trainerPage/modernV2.png";
import modernV2WebpImg from "../../assets/img/trainerPage/modernV2.webp";
import premiumImg from "../../assets/img/trainerPage/premium.png"
import classicImgWebp from "../../assets/img/trainerPage/classic.webp";
import modernImgWebp from "../../assets/img/trainerPage/modern.webp";
import modernV2ImgWebp from "../../assets/img/trainerPage/modernV2.webp";
import premiumImgWebp from "../../assets/img/trainerPage/premium.webp"

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Modal from "react-bootstrap/Modal"
import PremiumModal from "./PremiumModal";
import classes from "./Profile.module.css"
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import stripePromise from '../../payments/stripe'
import Alert from 'react-bootstrap/Alert'
import TrainerPageColors from "./TrainerPageColors/TrainerPageColors";
import TrainerPageImages from "./TrainerPagesImages/TrainerPagerImages";
import CustomizeServices from "./TrainerPageServices/TrainerPageServices";
import { Link } from "react-router-dom";
import { editTrainerPageHeader, getTrainerPageHeaders } from "../../state/trainerPageSlice";
import debounce from "lodash.debounce"
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";

import useCurrentUser from '../../hooks/useCurrentUser'

function Personalize({ personalizeData, editDBItem, errors, nameInUseError, zipCodeNotFound }) {
    const canShowOnFTG = useSelector(state => state.users.current_user.can_show_on_ftg)
    const [onlineTrainingChecked, setOnlineTrainingChecked] = useState(false);
    const [inPersonTrainingChecked, setInPersonTrainingChecked] = useState(false);


    const [countryOptions, setCountryOptions] = useState([]);
    const [country, setCountry] = useState(1);
    const [zipCode, setZipCode] = useState("");

    const [showPhone, setShowPhone] = useState(false);
    const [showEmail, setShowEmail] = useState(false);
    const [showPicture, setShowPicture] = useState(false);
    const [showBlogs, setShowBlogs] = useState(false);

    const [showClientTestimonials, setShowClientTestimonials] = useState(false);

    const [pageAddress, setPageAddress] = useState("");
    const [headline, setHeadline] = useState("");
    const [premiumModal, setPremiumModal] = useState(false);

    const [generalInformation, setGeneralInformation] = useState("");
    const [specialities, setSpecialties] = useState("");
    const [certifications, setCertifications] = useState("");

    const [clientName1, setClientName1] = useState("");
    const [clientName2, setClientName2] = useState("");
    const [clientName3, setClientName3] = useState("");

    const [clientTest1, setClientTest1] = useState("");
    const [clientTest2, setClientTest2] = useState("");
    const [clientTest3, setClientTest3] = useState("");

    const [templateSelected, setTemplateSelected] = useState(0)

    const [showPremiumModal, setShowPremiumModal] = useState(false)

    const [youtubeLink, setYoutubeLink] = useState("")
    const [instagramLink, setInstagramLink] = useState("")
    const [facebookLink, setFacebookLink] = useState("")
    const [twitterLink, setTwitterLink] = useState("")


    const user = useSelector((state) => state.users.current_user);

    const pageTypeText = (
        user.account_type === 'gym'
        ? 'Gym'
        : 'Trainer'
    )  

    const [backgroundColor, setBackgroundColor] = useState("");
    const [textButtonColor, setTextButtonColor] = useState("");
    const [buttonTextColor, setButtonTextColor] = useState("");

    const [customizeImagesShow, setCustomizeImagesShow] = useState(false);

    const [showLocationsTrainerPage, setShowLocationsTrainerPage] = useState(false);

    const [specialtyHeader, setSpecialtyHeader] = useState("");
    const [certificationHeader, setCertificationHeader] = useState("");

    let countryIsUnitedStates = country == "231";

    const trainerPageHeaders = useSelector((state) => state.trainerPage.trainerPageHeaders)

    const dispatch = useDispatch();
    const statusDispatch = useApiStatusDispatch();

    useEffect(() => {
        dispatch(getTrainerPageHeaders())
    }, [])
    console.log(trainerPageHeaders, "header");


    useEffect(() => {
        console.log("Fired");
        console.log(trainerPageHeaders);
        setSpecialtyHeader(trainerPageHeaders.specialty)
        setCertificationHeader(trainerPageHeaders.certifications)
    }, [trainerPageHeaders])


    useEffect(() => {
        if (personalizeData) {

            let bioData = personalizeData.user.bio_data;
            if (bioData) {
                let viewPageText
                setPageAddress(bioData.pageAddress);
                viewPageText = bioData.pageAddress ? "View Page as Others See It" : null;
                setHeadline(bioData.headline);
                bioData.inPersonTraining ? setInPersonTrainingChecked(true) : setInPersonTrainingChecked(false);
                bioData.onlineTraining ? setOnlineTrainingChecked(true) : setOnlineTrainingChecked(false);
                setShowLocationsTrainerPage(bioData.show_locations ? true : false);
                bioData.showClientTestimonials ? setShowClientTestimonials(true) : setShowClientTestimonials(false);
                bioData.showEmail ? setShowEmail(true) : setShowEmail(false);
                bioData.showPhone ? setShowPhone(true) : setShowPhone(false);
                bioData.showPicture ? setShowPicture(true) : setShowPicture(false);
                bioData.showBlogs ? setShowBlogs(true) : setShowBlogs(false);

                setZipCode(bioData.zipCode);
                setGeneralInformation(bioData.bio);
                setSpecialties(bioData.specialty);
                setCertifications(bioData.certifications);

                setCountry(bioData.country)
                setCountryOptions(Object.values(personalizeData.countries));

                setTemplateSelected(bioData.chosen_template)

                setClientName1(bioData.client_name_1);
                setClientName2(bioData.client_name_2);
                setClientName3(bioData.client_name_3);

                setClientTest1(bioData.client_testimonial_1);
                setClientTest2(bioData.client_testimonial_2);
                setClientTest3(bioData.client_testimonial_3);

                setYoutubeLink(bioData.youtube_link)
                setInstagramLink(bioData.instagram_link)
                setFacebookLink(bioData.facebook_link)
                setTwitterLink(bioData.twitter_link)

                setBackgroundColor(bioData.background_color ? bioData.background_color : "")

                setTextButtonColor(bioData.text_button_color ? bioData.text_button_color : "")

                setButtonTextColor(bioData.buttontext_color ? bioData.buttontext_color : "")
            }
        }
    }, [personalizeData])

    const debouncedDispatch = useCallback(debounce((title, header_type) =>
        saveToDb(title, header_type), 600), [])

    function saveToDb(title, header_type) {
        let payload = {
            title,
            header_type,
        }
        statusDispatch(editTrainerPageHeader(payload),"section header","update");
    }

    function handleTemplateSelect(name) {
        envAwarePost("api/users/api/", { value: name, action: 'updateChosenTemplate' })
            .then((res) => {
                if (res.success == "1") {
                    //console.log("success")
                } else {
                    console.log(res)
                }
            }).catch(err => console.log(err))

    }

    //get correct image based on template
    const templateImages = {
        classic: { base: classicImg, compressed: classicImgWebp },
        modern: { base: modernImg, compressed: modernImgWebp },
        modernV2: { base: modernV2Img, compressed: modernV2ImgWebp },
        premium: { base: premiumImg, compressed: premiumImgWebp }
    }

    //get correct title based on template
    const templateTitle = {
        modernV2: "Template 1",
        premium: "Template 2",
        modern: "Template 3",
        classic: "Template 4",
    }



    function renderTemplateOption(template) {
        return (
            <div className={`${classes.template} ${templateSelected === template ? "bg-info" : "bg-white"} px-2 py-2  `}
                onClick={(e) => {
                    handleTemplateSelect(template)
                    setTemplateSelected(template);
                }} >
                <div className={`${classes.templateHeader}`}> <h6> {templateTitle[template]} </h6> </div>
                <picture >
                    <source srcset={templateImages[template]['compressed']} />
                    <img height="300" width="167" src={templateImages[template]['base']} alt="modern template" loading="lazy" id="templateModern" data-no-retina />

                </picture>
            </div>
        )
    }

    return (
        <>
            {/* Personalized Page Section */}

            <Col style={{ backgroundColor: "#f7f8f9", padding: "20px", boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)", borderRadius: "5px" }} className="col-md-6 form-sections form-sections-padding-mobile pl-xl-3 pl-lg-3 pl-md-3">
                <div >
                    <h4>Personalized Page</h4>
                </div>
                <p>FitSW allows you to create your own free personalized page that you can share with potential or existing clients at www.fitsw.com/<b><i>YourPage</i></b> and it will also be featured on <a id="livePageLink" href="https://www.findtraingain.com" target="_blank" rel="noopener">FindTrainGain.com</a>
                    <OverlayTrigger overlay={
                        <Tooltip>
                            FindTrainGain is a site that helps potential clients find Personal Trainers. To be visible on findtraingain.com's trainer search, make sure to fill out the 'Headline' section and the rest of your profile                    </Tooltip>
                    }>
                        <i className="ml-1 fas fa-info-circle" style={{ marginTop: "5px" }} />
                    </OverlayTrigger>
                    <span>. After making customizations,<i> refresh your personalized {pageTypeText} Page to immediately see updates.</i></span>

                </p>
                {!canShowOnFTG &&
                    <Alert variant="danger" className="text-dark">
                        In order to be visible on FindTrainGain.com you must set a <a href="#headline">headline</a> below
                    </Alert>
                }
                {pageAddress ? <div className="mb-3"> <a id="livePageLink" href={`/${pageAddress}`} target="_blank" rel="noopener"> View Page as Others See It  </a> </div> : ""}

                {/* Page Address */}
                <Form.Group controlId="pageAddress">
                    <Form.Label className="col-form-label">
                        <u> Page Address </u>
                    </Form.Label>
                    <div className="form-inline">
                        www.fitsw.com/
                        <Form.Control type="text" className="form-control-alternative" name="pageAddress" id="pageAddress" value={pageAddress} placeholder="Your Page Address"
                            onChange={(e) => {
                                setPageAddress(e.target.value)
                                editDBItem(e)
                            }}
                        />
                    </div>
                    {errors && <div className="text-danger"> {errors.pageAddress} </div>}
                    {nameInUseError &&
                        <div className="text-danger">
                            Another trainer has already selected this name. Please try another.
                        </div>}
                </Form.Group>

                {/* what template would you like to use? */}
                <Form.Group controlId="chosen_template">
                    <Form.Label className="col-form-label">
                        <u> Choose A Template </u>
                    </Form.Label>

                    <Form.Text>
                        <div>
                            <div className="">
                                <div className={`${classes.templateContainer}`}>
                                    {renderTemplateOption("modernV2")}
                                    {renderTemplateOption("premium")}
                                </div>
                                <div className={`${classes.templateContainer}`}>
                                    {renderTemplateOption("modern")}
                                    {renderTemplateOption("classic")}

                                </div>
                            </div>

                        </div>
                    </Form.Text>
                </Form.Group>

                {/* Customize Colors */}
                <TrainerPageColors
                    backgroundColor={backgroundColor}
                    setBackgroundColor={setBackgroundColor}
                    textButtonColor={textButtonColor}
                    setTextButtonColor={setTextButtonColor}
                    setButtonTextColor={setButtonTextColor}
                    buttonTextColor={buttonTextColor}
                />

                {/*  Customize Images  */}
                <div className="mb-2"><u>  Images </u> </div>
                <Button
                    onClick={() => setCustomizeImagesShow(true)}
                    className="mb-2"
                    size="sm"
                >
                    Customize Images
                </Button>

                <TrainerPageImages customizeImagesShow={customizeImagesShow} setCustomizeImagesShow={setCustomizeImagesShow} />


                {/* Headline */}

                <Form.Group controlId="headline">
                    <Form.Label className="col-form-label">
                        <u>Headline</u>
                    </Form.Label>
                    <Form.Control name="headline" type="text" className="form-control-alternative" value={headline} placeholder="Headline of Your Page"
                        onChange={(e) => {
                            setHeadline(e.target.value)
                            editDBItem(e)
                        }}
                    />
                </Form.Group>

                {/* Services Offered by the trainer*/}
                <Form.Group controlId="servicesOffered">
                    <Form.Label className="col-form-label">
                        <u> Training locations </u>
                        <Form.Check
                            className="mt-2"
                            name="show_locations"
                            checked={showLocationsTrainerPage}
                            type="switch"
                            label={`Show on personalized ${pageTypeText} Page`}
                            onChange={(e) => {
                                setShowLocationsTrainerPage(prev => !prev)
                                editDBItem(e, 1)
                            }}
                        />
                    </Form.Label>
                    <Row className="mt-2">
                        <Col sm={6}>
                            <Form.Check type="checkbox" className="custom-control custom-checkbox" id="onlineTraining">
                                <Form.Check.Input name="onlineTraining" checked={onlineTrainingChecked} type="checkbox" className="custom-control-input"
                                    onChange={(e) => {
                                        setOnlineTrainingChecked(prev => !prev)
                                        editDBItem(e, 1)

                                    }} />
                                <Form.Check.Label className="custom-control-label"> Online Training </Form.Check.Label>
                            </Form.Check>
                        </Col>

                        <Col sm={6}>
                            <Form.Check type="checkbox" className="custom-control custom-checkbox" id="inPersonTraining">
                                <Form.Check.Input name="inPersonTraining" checked={inPersonTrainingChecked} type="checkbox" className="custom-control-input"
                                    onChange={(e) => {
                                        setInPersonTrainingChecked(prev => !prev)
                                        editDBItem(e, 1)
                                    }}
                                />
                                <Form.Check.Label className="custom-control-label"> In-Person Training </Form.Check.Label>
                            </Form.Check>
                        </Col>
                    </Row>
                </Form.Group>

                <div>
                    <div className="pb-1" > <u> Services </u> </div>
                    <div className="ml-2">
                        <Link to={"/trainerPageServices"}> <Button size="sm"> Manage Services </Button> </Link>
                    </div>
                </div>

                {/* Country of the Trainer */}

                <Form.Group controlId="country">
                    <Form.Label className="col-form-label">
                        <u> Country </u>
                    </Form.Label>
                    <Form.Control name="country" as="select" className="form-control-alternative" value={country} onChange={(e) => {
                        setCountry(e.target.value);
                        editDBItem(e)
                    }}
                    >
                        {
                            countryOptions && countryOptions.map((item, index) => {
                                return <option key={index} value={index + 1}> {item} </option>
                            })
                        }
                    </Form.Control>
                </Form.Group>

                {/* Postal Code of the Trainer */}
                {countryIsUnitedStates && <Form.Group controlId="zipCode" >
                    <Form.Label> <u> Postal Code</u> (U.S only)
                        <OverlayTrigger overlay={
                            <Tooltip>
                                Enter a US postal code and select in-person training to appear on Findtraingain.com's In-person search (world-wide search to be added in the future)
                            </Tooltip>
                        }>
                            <i className="ml-1 fas fa-info-circle" style={{ marginTop: "5px" }} />
                        </OverlayTrigger>

                    </Form.Label>
                    <Form.Control name="zipCode" className="form-control-alternative" type="text" placeholder="ZIP or Postal Code" value={zipCode}
                        onChange={(e) => {
                            setZipCode(e.target.value);
                            editDBItem(e);
                        }} />
                    {zipCodeNotFound && <div className="text-danger"> Zip Code not found</div>}

                </Form.Group>}

                {/* Options for the trainer to choose what to show on their page  */}
                <Form.Group controlId="servicesOffered">
                    <Form.Label className="col-form-label">
                        <u> Personal Page Display </u>
                    </Form.Label>
                    <Row className="mt-4 mb-2">
                        <Col sm={6}>
                            <Form.Check type="checkbox" className="custom-control custom-checkbox" id="showPhoneNumber">
                                <Form.Check.Input name="showPhone" checked={showPhone} type="checkbox" onChange={(e) => { setShowPhone(prev => !prev); editDBItem(e, 1) }} className="custom-control-input" />
                                <Form.Check.Label className="custom-control-label"> Show Phone Number </Form.Check.Label>
                            </Form.Check>
                        </Col>

                        <Col sm={6}>
                            <Form.Check type="checkbox" className="custom-control custom-checkbox" id="showEmail">
                                <Form.Check.Input name="showEmail" checked={showEmail} type="checkbox" onChange={(e) => { setShowEmail(prev => !prev); editDBItem(e, 1) }} className="custom-control-input" />
                                <Form.Check.Label className="custom-control-label"> Show Email </Form.Check.Label>
                            </Form.Check>
                        </Col>
                    </Row>
                    <Row className="mt-4" >
                        <Col sm={6}>
                            <Form.Check type="checkbox" className="custom-control custom-checkbox" id="showPicture">
                                <Form.Check.Input name="showPicture" checked={showPicture} type="checkbox" onChange={(e) => { setShowPicture(prev => !prev); editDBItem(e, 1) }} className="custom-control-input" />
                                <Form.Check.Label className="custom-control-label"> Show Picture </Form.Check.Label>
                            </Form.Check>
                        </Col>

                        <Col sm={6}>
                            <Form.Check type="checkbox" className="custom-control custom-checkbox" id="showClientTestimonials">
                                <Form.Check.Input name="showClientTestimonials" checked={showClientTestimonials} type="checkbox" onChange={(e) => { setShowClientTestimonials(prev => !prev); editDBItem(e, 1) }} className="custom-control-input" />
                                <Form.Check.Label className="custom-control-label"> Show Client Testimonials </Form.Check.Label>
                            </Form.Check>
                        </Col>
                    </Row>
                    <Row className="mt-4" >
                        <Col sm={6}>
                            <Form.Check type="checkbox" className="custom-control custom-checkbox" id="showBlogs">
                                <Form.Check.Input name="showBlogs" checked={showBlogs} type="checkbox" onChange={(e) => { setShowBlogs(prev => !prev); editDBItem(e, 1) }} className="custom-control-input" />
                                <Form.Check.Label className="custom-control-label"> Show Blogs </Form.Check.Label>
                            </Form.Check>
                        </Col>
                    </Row>
                </Form.Group>

                {/* General Information of the trainer */}

                <Form.Group controlId="bio">
                    <Form.Label className="col-form-label"><u> General Information </u></Form.Label>
                    <Form.Control name="bio" as="textarea" className="form-control-alternative" rows={4} value={generalInformation}
                        onChange={(e) => {
                            setGeneralInformation(e.target.value)
                            editDBItem(e)
                        }} />
                </Form.Group>

                {/* Certifications of the trainer  */}
                <u> {certificationHeader} </u>
                <Form.Group controlId="certifications">
                    <Form.Label
                        className="col-form-label"
                    >
                        Section Title
                    </Form.Label>
                    <Form.Control 
                        value={certificationHeader}
                         onChange={(e) => {
                             setCertificationHeader(e.target.value)
                             debouncedDispatch(e.target.value, "certifications_renamed")
                            }} />
                </Form.Group>
                <Form.Group controlId="specialtyBody">
                    <Form.Label
                        className="col-form-label"
                    >
                        Section Content
                    </Form.Label>
                    <Form.Control name="certifications" as="textarea" className="form-control-alternative" rows={4} value={certifications}
                        onChange={(e) => {
                            setCertifications(e.target.value)
                            editDBItem(e)
                        }} />
                </Form.Group>

                {/* Specialties of the trainer  */}
                <u> {specialtyHeader} </u>
                <Form.Group controlId="specialtyHeader">
                    <Form.Label
                        className="col-form-label"
                    >
                        Section Title
                    </Form.Label>
                    <Form.Control
                     value={specialtyHeader} 
                    onChange={(e) => {
                        setSpecialtyHeader(e.target.value)
                        debouncedDispatch(e.target.value, "specialty_renamed")
                    }} />
                </Form.Group>
                <Form.Group controlId="specialtyBody">
                    <Form.Label
                        className="col-form-label"
                    >
                        Section Content
                    </Form.Label>
                    <Form.Control name="specialty" as="textarea" className="form-control-alternative" rows={4} value={specialities}
                        onChange={(e) => {
                            setSpecialties(e.target.value)
                            editDBItem(e)
                        }} />
                </Form.Group>

                {/* social media links section  */}
                <Form.Group >
                    <u>Social Media Links</u>
                    <hr></hr>
                    <Form.Label className="col-form-label" for="instagram_link"><u>Instagram</u></Form.Label>
                    <Form.Control name="instagram_link" id="instagram_link" as="textarea" className="form-control-alternative" rows={1} value={instagramLink}
                        onChange={(e) => {
                            setInstagramLink(e.target.value)
                            editDBItem(e)
                        }} />
                    <Form.Label className="col-form-label" for="youtube_link"><u>Youtube</u></Form.Label>
                    <Form.Control name="youtube_link" id="youtube_link" as="textarea" className="form-control-alternative" rows={1} value={youtubeLink}
                        onChange={(e) => {
                            setYoutubeLink(e.target.value)
                            editDBItem(e)
                        }} />
                    <Form.Label className="col-form-label" for="facebook_link"><u>Facebook</u></Form.Label>
                    <Form.Control name="facebook_link" id="facebook_link" as="textarea" className="form-control-alternative" rows={1} value={facebookLink}
                        onChange={(e) => {
                            setFacebookLink(e.target.value)
                            editDBItem(e)
                        }} />
                    <Form.Label className="col-form-label" for="twitter_link"><u>Twitter</u></Form.Label>
                    <Form.Control name="twitter_link" id="twitter_link" as="textarea" className="form-control-alternative" rows={1} value={twitterLink}
                        onChange={(e) => {
                            setTwitterLink(e.target.value)
                            editDBItem(e)
                        }} />
                </Form.Group>
                <hr></hr>
                {/* client testimonials section  */}

                <div className='client-testimonials'>
                    {/* client testimonials #1  */}
                    <Form.Group >
                        <Form.Label id="client_name_2" className="col-form-label"><u> Client Testimonial #1 </u></Form.Label>
                        <div className="client-testimonial-1">
                            <Form.Control id="client_name_1" name="client_name_1" type="text" className="form-control-alternative mb-2" placeholder="Client Name" value={clientName1}
                                onChange={(e) => {
                                    setClientName1(e.target.value);
                                    editDBItem(e);
                                }}
                            />
                            <Form.Control id="client_testimonial_1" name="client_testimonial_1" as="textarea" placeholder="Client Testimony" className="form-control-alternative" rows={4} value={clientTest1}
                                onChange={(e) => {
                                    setClientTest1(e.target.value);
                                    editDBItem(e);
                                }} />
                        </div>
                    </Form.Group>

                    {/* client testimonials #2  */}

                    <Form.Group >
                        <Form.Label className="col-form-label">
                            <u> Client Testimonial #2</u>
                        </Form.Label>

                        <div className="client-testimonial-2">
                            <Form.Control id="client_name_2" name="client_name_2" type="text" className="form-control-alternative mb-2" placeholder="Client Name" value={clientName2}
                                onChange={(e) => {
                                    setClientName2(e.target.value);
                                    editDBItem(e);
                                }} />
                            <Form.Control id="client_testimonial_2" name="client_testimonial_2" as="textarea" placeholder="Client Testimony" className="form-control-alternative" rows={4} value={clientTest2}
                                onChange={(e) => {
                                    setClientTest2(e.target.value);
                                    editDBItem(e);
                                }} />
                        </div>
                    </Form.Group>

                    {/* client testimonials #3  */}

                    <Form.Group >
                        <Form.Label className="col-form-label"><u> Client Testimonial #3 </u></Form.Label>
                        <div className="client-testimonial-3">
                            <Form.Control id="client_name_3" type="text" name="client_name_3" className="form-control-alternative mb-2" placeholder="Client Name" value={clientName3}
                                onChange={(e) => {
                                    setClientName3(e.target.value);
                                    editDBItem(e);
                                }} />
                            <Form.Control id="client_testimonial_3" as="textarea" name="client_testimonial_3" placeholder="Client Testimony" className="form-control-alternative" rows={4} value={clientTest3}
                                onChange={(e) => {
                                    setClientTest3(e.target.value);
                                    editDBItem(e);
                                }} />
                        </div>
                    </Form.Group>
                </div>

            </Col>

        </>
    )
}

export default Personalize